import * as actions from "./pool-actions";

const poolReducer = (state, action) => {
    switch (action.type) {
        case actions.INIT_SALE_EVENT:
            return {
                ...state,
                ...action.payload,
            };
        case actions.UPDATE_SALE_EVENT:
            return {
                ...state,
                currentTimelineStep:
                    action.payload.currentTimelineStep || state.currentTimelineStep,
                saleContract: {
                    ...state.saleContract,
                    ...action.payload.saleContract,
                },
                saleEvent: {
                    ...state.saleEvent,
                    ...action.payload.saleEvent,
                },
                layoutContentDef: action.payload.layoutContentDef || state.layoutContentDef,
            };
        case actions.UPDATE_TIMELINE:
            return {
                ...state,
                saleEvent: {
                    ...state.saleEvent,
                    countdown: {
                        ...state.saleEvent.countdown,
                        ...action.payload.countdown,
                    },
                },
                currentTimelineStep:
                    action.payload.currentTimelineStep || state.currentTimelineStep,
                layoutContentDef: {
                    tokenSaleHero: action.payload.tokenSaleHero,
                    purchaseForm: action.payload.purchaseForm,
                },
            };

        case actions.UPDATE_PURCHASE_PROGRESS:
            return {
                ...state,
                saleEvent: {
                    ...state.saleEvent,
                    saleProgress: action.payload.saleProgress,
                },
            };
        default:
            return state;
    }
};

export default poolReducer;
